import React, {useEffect, useState} from 'react';
import {Button, Col, Flex, Form, Input, Popover, Select, Steps, StepsProps} from "antd";
import Header from "../../components/header/Header";
import BackGroundLogo from "../../components/adBackGroundLogo/BackGroundLogo";
import { GuaranteeCard} from "../../components";
import {useForm} from "antd/es/form/Form";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import PriceCard from "../../components/priceCard/PriceCard";
import style from "./AInsertStepTow.module.scss"
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import PropertiesCard from "../../components/propertiesCard/PropertiesCard";
import ConditionsCard from "../../components/conditionsCard/ConditionsCard";
import {registerProduct} from "../../actions/AdInsert.action";
import {AdInsertStepTwoProps} from "../../models";
import {StyledSteps} from "../AdInsertSteps.styled";

const AdEditStepTwo = ({registerProduct}:AdInsertStepTwoProps) => {
    const [form] = useForm();
    const [price, setPrice] = useState()
    const { id } = useParams();
    const [GuaranteeCards, setGuaranteeCard] = useState()
    const [PropertiesCards, setPropertiesCard] = useState()
    const [ConditionsCards, setConditionsCard] = useState()
    const onFinish = (value: any) => {
        value= location.state.stepOneForm
        value.ownerId= "7a36ceff-4848-4448-baf2-4d2a6c328a68"
        value.productAssurances =GuaranteeCards
        value.productConditions =ConditionsCards
        value.productProperties =PropertiesCards
        value.productPricings =price
        value.productId =location.state?.stepTwoForm?.productId
        value.productImages =[]
        navigate('/ad-edit-step-three/'+id,{state:{
                stepTwoForm:value,stepOneForm:location.state.stepOneForm,productImages:location.state?.productImages
            }})

    }
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        console.log(location.state?.stepTwoForm)
        if (location.state?.stepTwoForm){
            setPrice(location.state?.stepTwoForm?.productPricings);
            setGuaranteeCard(location.state?.stepTwoForm?.productAssurances);
            setPropertiesCard(location.state?.stepTwoForm?.productProperties);
            setConditionsCard(location.state?.stepTwoForm?.productConditions);
        }
    }, [location]);
    const customDot: StepsProps['progressDot'] = (dot, { status, index }) => (
        <Popover

        >
            {dot}
        </Popover>
    );

    return (
        <Flex vertical gap={"small"}>
            <Header step={2}/>
           <div className={style.customDiv}>
               <StyledSteps direction={"vertical"}
                   progressDot={customDot}
                   current={1}
                   items={[
                       {
                           title: '1 : اطلاعات آگهی',

                       },
                       {
                           title: '2 : جزئیات آگهی',
                       },
                       {
                           title: '2 : عکس آگهی',
                       },
                   ]}
               />
               <Flex vertical gap={"small"}>
                   <PriceCard onConfirm={(form:any) => {setPrice(form)}}/>
                   <GuaranteeCard  onConfirm={(form:any) => {setGuaranteeCard(form)}}/>
                   <PropertiesCard  onConfirm={(form:any) => {setPropertiesCard(form)}}/>
                   <ConditionsCard  onConfirm={(form:any) => {setConditionsCard(form)}}/>
                   <Form form={form} onFinish={onFinish}>
                       <Flex gap={"small"} className={style.customBtns}>
                           <Button  htmlType={"submit"} size={"large"} type={"primary"} block> ادامه</Button>
                           <Button onClick={() => navigate( `/ad-edit-step-one/${id}`,{state:{
                                   stepOneForm:location.state.stepOneForm,
                                   stepTwoForm:{
                                       productAssurances : GuaranteeCards,
                                       productConditions : ConditionsCards,
                                       productProperties : PropertiesCards,
                                       productPricings : price,
                                   }
                               }})} size={"large"}  block >مرحله قبل</Button>
                       </Flex>
                   </Form>
               </Flex>
           </div>
        </Flex>
    );
};

export default connect(null, {registerProduct})(withRouter(AdEditStepTwo));
